import Vue from 'vue'
import VueRouter from 'vue-router'
// 修复router不能push,或者replace自己的bug
const [routerPush, routerReplace] = [VueRouter.prototype.push, VueRouter.prototype.replace];
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};
VueRouter.prototype.replace = function replace(location) {
  return routerReplace.call(this, location).catch(error => error);
};

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/pages/layout/index.vue'),
    meta: {}
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/pages/login/login.vue'),
    meta: {}
  },
  {
    path: '/forbidden',
    name: 'Forbidden',
    component: () => import('@/pages/error/forbidden.vue'),
    meta: {}
  },
  {
    path: '/error',
    name: 'Error',
    component: () => import('@/pages/error/error.vue'),
    meta: {}
  },
  {
    path: '/success',
    name: 'Success',
    component: () => import('@/pages/error/success.vue'),
    meta: {}
  },
  {
    path: '*',
    name: 'NotFound',
    component: () => import('@/pages/error/404.vue'),
    meta: {}
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
